import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest, { UserRequestSpec } from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

export interface UpsertExternalIntegrationDto {
  name?: string;
}

export interface ExternalIntegrationRegisteredDto {
  clientId: string;
  secret: string;
}

const registerSpec = (businessId: string): UserRequestSpec => ({
  path: `/api/businesses/${businessId}/registerExternalIntegration`,
  method: HttpMethod.POST,
});

const useRegisterExternalIntegration = (options?: RequestOptions<ExternalIntegrationRegisteredDto>) => {
  const business = useSelectedBusiness();
  return useUserRequest<UpsertExternalIntegrationDto, ExternalIntegrationRegisteredDto>(
    registerSpec(business.id), options);
}

export default useRegisterExternalIntegration;
